import { Component, ViewChild, ChangeDetectionStrategy } from '@angular/core';

import { MatDialogModule } from '@angular/material/dialog';
import { MatButtonModule } from '@angular/material/button';
import { DynamicTableComponent } from '../../dynamic-table/dynamic-table.component';

@Component({
  selector: 'app-suggested-locations-dialog',
  standalone: true,
  imports: [MatDialogModule, MatButtonModule, DynamicTableComponent],
  template: `
    <div class="sld-dialog">
      <h2 mat-dialog-title>Foreslåede lokationer</h2>
      <mat-dialog-content class="sld-content">
        <p class="sld-hint">
          Disse stationer er knyttet til brugeres roller, men findes endnu ikke
          som lokationer i systemet. Opret dem her.
        </p>
        <app-dynamic-table
          #table
          [dynamicInput]="dynamicInput"
        ></app-dynamic-table>
      </mat-dialog-content>
      <mat-dialog-actions align="end">
        <button mat-button mat-dialog-close type="button">Luk</button>
      </mat-dialog-actions>
    </div>
  `,
  changeDetection: ChangeDetectionStrategy.Eager,
  styles: [
    `
      .sld-dialog {
        min-width: 960px;
        max-width: 1400px;
        width: 90vw;
      }
      h2 {
        margin: 0 0 8px;
        font-size: 1.2rem;
        font-weight: 600;
      }
      .sld-content {
        padding-top: 4px;
        overflow-x: auto;
      }
      .sld-hint {
        margin: 0 0 12px;
        line-height: 1.45;
        color: var(--mat-sys-on-surface-variant, rgba(0, 0, 0, 0.65));
        font-size: 0.9rem;
      }
    `,
  ],
})
export class SuggestedLocationsDialogComponent {
  @ViewChild('table') table?: DynamicTableComponent;

  readonly dynamicInput = {
    dataSource: { type: 'text', value: 'locations_suggested_admin' },
  };

  refreshTable(): void {
    this.table?.refreshTable();
  }
}
